// extracted by mini-css-extract-plugin
module.exports = {"collapsibleTitle":"styles_collapsibleTitle__2trm8"};